import "./namespace.js";
import "../../utilities/scroll_to_top.js";

(function () {
  window.Behaviours.AjaxContent = {
    // Fetches content from an endpoint and injects it into the element
    fetch: function (element) {
      var element = jQuery(element);
      var url = element.data("ajax-content-url") || element.attr("href");
      var targetSelector = element.data("ajax-target-selector");
      var target = targetSelector ? jQuery(targetSelector) : element;
      var selector = element.data("ajax-content-selector");

      return jQuery
        .ajax({ url: url, headers: { "X-Requested-With": "XMLHttpRequest" }, dataType: "html" })
        .done(function (content) {
          content = content || "";
          if (selector) {
            content = jQuery("<html>").html(content).find(selector);
            target.replaceWith(content);
          } else if (content.indexOf("</body>") === -1) {
            target.replaceWith(content);
          } else {
            console.error("Content contained a <body> element which may indicate something went wrong server-side.");
          }
        });
    },
  };

  // BEHAVIOUR

  jQuery(document).on("click", '[data-behaviour~="ajax-content-link"]', handleLinkClick);

  // EVENT HANDLERS

  function handleLinkClick(event) {
    event.preventDefault();
    var element = jQuery(this);
    if (element.attr("data-loading")) {
      return;
    }
    var targetSelector = element.data("ajax-target-selector");
    if (targetSelector) {
      Sparkle.Utilities.scrollToTop(targetSelector);
    }
    element.attr("data-loading", true);
    window.Behaviours.AjaxContent.fetch(element).fail(function () {
      element.attr("data-loading", false);
    });
  }

  // INITIALIZE

  jQuery(function () {
    jQuery('[data-behaviour~="ajax-content"]').each(function () {
      window.Behaviours.AjaxContent.fetch(this);
    });
  });
})();
